import React from "react";
import { Box, Flex, HStack, Image } from "@chakra-ui/react";

import { useAuth0 } from "@auth0/auth0-react";
import UserMenu from "../NavBar/Components/UserMenu";
import { useNavigate } from "react-router-dom";
import LangSelectV2 from "../NavBar/LangSelectV2";

const Header: React.FC = () => {
  const { user, isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  return (
    <Flex flexDir={"row"} justifyContent={"space-between"}>
      <Box
        p={6}
        onClick={() => {
          navigate("/edit");
        }}
        cursor={"pointer"}
      >
        <Image
          w={"144px"}
          h={"40px"}
          objectFit="contain"
          src={"/static/doenba-logo-blue.png"}
        />
      </Box>
      <Flex flexDir={"row"} h={"90px"} justify="space-between" align="center">
        <HStack>
          <Box minWidth={"120px"}>
            <LangSelectV2 />
          </Box>
          {isAuthenticated && user && <UserMenu user={user} />}
        </HStack>
      </Flex>
    </Flex>
  );
};

export default Header;
